<script setup>
import { ref, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import OsTopbar from 'dashboard/components-next/os/OsTopbar.vue';
import PowerAppView from './PowerAppView.vue';

const route = useRoute();
const appName = ref('');
// O topbar flutua sobre o app em vez de empurrá-lo: aparece com o cursor na faixa
// do topo e some quando ele sai. O app fica com a tela inteira.
const isTopbarOpen = ref(false);

// The token endpoint returns only token + url, so the display name comes from
// the registry listing — which also keeps deep links (no Home visit) labelled.
const loadName = async () => {
  appName.value = '';
  const { accountId, slug } = route.params;
  try {
    const { data } = await window.axios.get(
      `/api/v1/accounts/${accountId}/powerapps`
    );
    appName.value = data.find(app => app.slug === slug)?.name || '';
  } catch {
    appName.value = '';
  }
};

onMounted(loadName);
watch(() => [route.params.accountId, route.params.slug], loadName);
</script>

<template>
  <div class="relative flex flex-col w-full h-full min-h-0 bg-n-background">
    <!-- Fechado, só a faixa de 8px no topo recebe o cursor; o resto é do app.
         O cursor que entra no iframe dispara o mouseleave daqui. -->
    <div
      class="absolute inset-x-0 top-0 z-20"
      :class="{ 'h-2 overflow-hidden': !isTopbarOpen }"
      @mouseenter="isTopbarOpen = true"
      @mouseleave="isTopbarOpen = false"
    >
      <OsTopbar
        show-back-to-home
        :title="appName"
        class="shadow-md transition-opacity duration-200"
        :class="isTopbarOpen ? 'opacity-100' : 'opacity-0'"
      />
    </div>
    <div class="flex flex-1 min-h-0">
      <PowerAppView />
    </div>
  </div>
</template>
